import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-card',
  imports: [
    MatTooltipModule,
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
  @Input() heading: string = '';
  @Input() tooltip: string = '';
  @Output() infoHover = new EventEmitter<void>();

  onInfoHover() {
    this.infoHover.emit();
  }
}
